import React, { useCallback, useState } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Input, message } from 'antd';
import { applyBlackList } from 'setting/api/standalone';

import style from './index.less';

import { FormComponentProps } from '@ant-design/compatible/lib/form';

interface IProps extends FormComponentProps {
  visible: boolean;
  form: any;
  handleCancel: () => void;
  onApplySuccess: () => void;
  idParams?: any;
}

const { TextArea } = Input;

const BlockApply: React.FC<IProps> = ({ visible, form, handleCancel, onApplySuccess, idParams }) => {
  const { getFieldDecorator, validateFields, getFieldValue } = form;

  const content = getFieldValue('content') || '';

  const [loading, setLoading] = useState(false);
  const handleOk = useCallback(() => {
    validateFields((error: any, values: { content: any }) => {
      if (!error) {
        setLoading(true);
        applyBlackList({
          conv_id: idParams.convId,
          track_id: idParams.trackId,
          visit_id: idParams.visitId,
          block_reason: values.content
        })
          .then(() => {
            message.success('申请成功！');
            setLoading(false);
            handleCancel();
            onApplySuccess();
          })
          .catch(err => {
            handleCancel();
            setLoading(false);
          });
      }
    });
  }, [idParams]);

  return (
    <Modal
      title={'加入黑名单'}
      className={style.apply}
      open={visible}
      width={560}
      confirmLoading={loading}
      onOk={handleOk}
      destroyOnClose={true}
      onCancel={handleCancel}
    >
      <Form className={style.form}>
        <Form.Item label={'申请理由'}>
          {getFieldDecorator('content', {
            initialValue: '',
            rules: [{ required: true, message: '请输入申请理由' }]
          })(<TextArea maxLength={300} placeholder={'请输入'} />)}
        </Form.Item>
        <p className={style.info}>{content.length}/300</p>
      </Form>
    </Modal>
  );
};

export default (Form.create<IProps>({ name: 'editDocument' })(BlockApply) as unknown) as any;
